import { useTranslation } from 'react-i18next';

import {
  StyledReferralCardsContainer,
  StyledWrapper,
} from './MyReferrals.styles';
import { IMyReferralsProps } from './MyReferrals.types';
import ReferralCard from './ReferralCard';
import { IReferral } from '../../types';
import { StyledH2 } from '../UI/Typography';

const MyReferrals = ({ referrals }: IMyReferralsProps): JSX.Element => {
  const { t } = useTranslation(['common']);

  return (
    <StyledWrapper>
      <StyledH2>{t('common:myReferrals')}</StyledH2>
      <StyledReferralCardsContainer>
        {referrals.map((referral: IReferral, index) => (
          <ReferralCard
            key={index}
            name={referral.name}
            status={referral.status}
            date={referral.creationDate}
            city={referral.city.name}
          />
        ))}
      </StyledReferralCardsContainer>
    </StyledWrapper>
  );
};

export default MyReferrals;
